import { render, staticRenderFns } from "./KirjauduUudelleenohjaus.vue?vue&type=template&id=12fb2454&scoped=true&"
import script from "./KirjauduUudelleenohjaus.vue?vue&type=script&lang=js&"
export * from "./KirjauduUudelleenohjaus.vue?vue&type=script&lang=js&"
import style0 from "./KirjauduUudelleenohjaus.vue?vue&type=style&index=0&id=12fb2454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb2454",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12fb2454')) {
      api.createRecord('12fb2454', component.options)
    } else {
      api.reload('12fb2454', component.options)
    }
    module.hot.accept("./KirjauduUudelleenohjaus.vue?vue&type=template&id=12fb2454&scoped=true&", function () {
      api.rerender('12fb2454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KirjauduUudelleenohjaus.vue"
export default component.exports